import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {map, Observable} from "rxjs";
import {Event, EventSponsor} from "../types/event";
import {Meta, Title} from "@angular/platform-browser";
import {environment} from "../../../environments/environment";
import {NotFoundComponent} from "../../not-found/not-found.component";
import {WebpImageComponent} from "../../components/webp-image/webp-image.component";

@Component({
  selector: 'app-event',
  standalone: true,
  imports: [CommonModule, NotFoundComponent, WebpImageComponent],
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.less']
})
export class EventComponent implements OnInit {
  public event$!: Observable<Event>;
  protected pageNotFound: boolean = false;

  public constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private meta: Meta,
  ) {
  }

  ngOnInit(): void {
    this.event$ = this.route.data.pipe(
      map(
        data => data['event']
      )
    );

    this.event$.subscribe(event => {
      if (event === null) {
        this.pageNotFound = true;
        this.meta.removeTag('name="description"');
        this.titleService.setTitle('404 Nicht gefunden');
      } else {
        this.pageNotFound = false;
        this.meta.removeTag('name="description"');
        this.titleService.setTitle(event.name);
        if (event.metaDescription) {
          this.meta.addTag({name: 'description', content: event.metaDescription});
        }
      }
    })
  }

  public getEventPrices(event: Event): string {
    if (!event.priceMin && !event.priceMax) {
      return '';
    }

    let prices: string = '';
    if (event.priceMin) {
      prices += event.priceMin.toFixed(2).replace('.', ',');

      if (event.priceMax) {
        prices += `&ndash;`
      }
    }

    if (event.priceMax) {
      prices += event.priceMax.toFixed(2).replace('.', ',');
    }

    prices += ' &euro;';

    return prices;
  }

  public getHeaderStyle(event: Event): object {
    let styles: any = {};

    // Use headerImage if available, fallback to regular image
    const imageUrl = event.headerImageUrl || event.imageUrl;

    if (imageUrl) {
      const webpUrl = imageUrl.replace(/\.(jpe?g|png)$/i, '.webp');
      // Use image-set for WebP with fallback
      styles.backgroundImage = `image-set(url(${webpUrl}) type("image/webp"), url(${imageUrl}))`;
    }

    return styles;
  }

  public getCopyrights(event: Event): string {
    return event.copyrights || event.name;
  }

  public sponsorLogoUrl(sponsor: EventSponsor): string {
    return `${environment.cdn.url}/cdn/${sponsor.logoUrl}`;
  }

  public sponsorsTitle(event: Event): string {
    return event.sponsorsTitle ?? 'Sponsors of Event';
  }
}
